import React from 'react';

import { MultiSelect } from 'react-multi-select-component';

import iconPolygon from 'assets/img/icon/icon_polygon.png';
import iconPolygonLight from 'assets/img/icon/ic_arrow-dark.png';
import { map, filter, indexOf } from 'lodash';

function RenderMultiSelect({
  input,
  className,
  disabled,
  opts,
  lang,
  theme,
  meta: { touched, error },
}) {
  const [selected, setSelected] = React.useState([]);
  const overrideStringsVi = {
    allItemsAreSelected: 'Tất cả',
    clearSearch: 'Xóa tìm kiếm',
    clearSelected: 'Đã xóa',
    noOptions: 'Không có dữ liệu',
    search: 'Nhập để tìm',
    selectAll: 'Chọn tất cả',
    selectAllFiltered: 'Chọn tất cả (Filtered)',
    selectSomeItems: 'Chọn...',
    create: 'Tạo mới',
  };
  const overrideStringsEn = {
    allItemsAreSelected: 'All',
    clearSearch: 'Clear Search',
    clearSelected: 'Clear Selected',
    noOptions: 'No options',
    search: 'Search',
    selectAll: 'Select All',
    selectAllFiltered: 'Select All (Filtered)',
    selectSomeItems: 'Select...',
    create: 'Create',
  };

  React.useEffect(() => {
    if (input.value) {
      const _arrIndustryCode = input.value.split(',');
      const _industrySaved = filter(
        opts,
        (o) => indexOf(_arrIndustryCode, o.value) > -1
      );
      setSelected(_industrySaved);
    } else {
      setSelected([]);
    }
    return () => {
      // cleanup
    };
  }, [input.value]);

  function handleChange(e) {
    setSelected(e);
    console.log(e);
    if (input.onChange) {
      input.onChange(map(e, 'value').join(','));
    }
  }

  const customValueRenderer = (selected, _options) => {
    // console.log(selected, opts)
    if(selected.length === opts.length) return  lang === 'en' ? 'Select all' : 'Chọn tất cả';

    return selected.length
      ? map(selected, 'label').join(',')
      : 'Chọn ngành ...';
  };

  const ArrowRenderer = () => <img style={{height: '6px', width: '10px'}} src={theme === 'dark' ? iconPolygon : iconPolygonLight} alt="" />;

  console.log(input.value);

  return (
    <MultiSelect
      options={opts}
      hasSelectAll={true}
      isLoading={false}
      shouldToggleOnHover={false}
      disableSearch={false}
      value={selected}
      disabled={disabled || false}
      onChange={handleChange}
      ArrowRenderer={ArrowRenderer}
      onMenuToggle={(s) => {
        console.debug('Select Toggle: ', s);
      }}
      valueRenderer={customValueRenderer}
      labelledBy={'Chọn ngành'}
      className={className}
      overrideStrings={lang === 'en' ? overrideStringsEn : overrideStringsVi}
      //   onCreateOption={handleNewField}
    />
  );
}

export default RenderMultiSelect;

{
  /* <select
      {...input}
      className={className}
      style={{
        borderColor: `${touched && error ? '#FF0000' : '#343142'}`,
      }}
      disabled={disabled}
    >
      {opts &&
        !!opts.length &&
        opts.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
    </select> */
}
